export function initMultipleDownloadButtons(scope: Document | HTMLElement = document): void {
  scope.querySelectorAll('.js-multipleDownload').forEach((button) => {
    if (button.querySelectorAll('span.button__inner').length > 0) {
      return;
    }
    const innerButtons = button.querySelectorAll('.button');
    innerButtons.forEach((innerButton) => {
      innerButton.classList.add('button__innerLink');
      innerButton.classList.remove('button');
      innerButton.classList.remove('button--download');
      innerButton.classList.remove('button--outline');
    });
    const innerHtml = button.innerHTML;
    const indexOfFirstButton = innerHtml.indexOf('<');
    if (indexOfFirstButton > 0) {
      button.innerHTML = `${innerHtml.substring(0, indexOfFirstButton)}<span class="button__inner">${innerHtml.substring(indexOfFirstButton)}</span>`;
    }

    button.removeEventListener('click', toggleMultipleDownloadButton);
    button.addEventListener('click', toggleMultipleDownloadButton);
  });
}

function toggleMultipleDownloadButton(clickEvent) {
  const target = clickEvent.target;
  const parent = target.parentElement;
  document.querySelectorAll('.button--multipleDownload.button--active').forEach((button) => {
    if (button !== target && button !== parent) {
      button.classList.remove('button--active');
    }
  });
  if (target instanceof HTMLElement) {
    target.classList.toggle('button--active');
  }

  document.querySelectorAll('.contenttable__wrapper').forEach((table) => {
      if (table.contains(target as HTMLElement)) {
        table.classList.toggle('contenttable__wrapper--noScroll');
      }
    },
  );
}
